export const USE_BEARBY_PROVIDER = '`useBearby` should be used within a `BearbyProvider`';
